<template>
	<div style="height: 100%; position: relative;">
		<div
			id="d001"
			class=""
			style="position: absolute; top: 0; left: 0; right: 0; bottom: 40px;"
		></div>
		<div
			class="center"
			style="position: absolute; bottom: 0; left: 0; right: 0;"
		>
			<span class="dot bcPrimary"></span> {{ overview[0].NAME }}&nbsp;
			<span class="dot bcSecondary"></span> {{ overview[1].NAME }}&nbsp;
			<span v-if="overview.length === 3"
				><span class="dot bcTertiary"></span> {{ overview[2].NAME }}</span
			>
		</div>
	</div>
</template>

<script>
/* tslint:disable */
import Highcharts from "highcharts";
import Vue from "vue";
import { colors } from "@/config";

export default {
	name: "D001",
	components: {},
	props: {
		overview: Array,
		profitloss: Array,
	},

	computed: {
		longest() {
			let l = 0;
			let x = 0;
			for (let i = 0; i < this.profitloss.length; i++) {
				if (this.profitloss[i].sheets.length > l) {
					l = this.profitloss[i].sheets.length;
					x = i;
				}
			}
			return x;
		},
	},

	mounted() {
		this.chart = new Highcharts.chart({
			chart: {
				type: "column",
				renderTo: "d001",
				backgroundColor: "transparent",
			},

			credits: {
				enabled: false,
			},

			title: {
				text: "",
			},

			legend: {
				enabled: false,
			},

			colors: [colors.Primary, colors.Secondary, colors.Tertiary],

			xAxis: {
				categories: this.profitloss[this.longest].sheets.map((s, i) =>
					i === 0 ? Vue.prototype.$t("Senaste bokslutet") : ""
				),
				labels: {
					style: { fontSize: "1rem", color: colors.Black, },
				},
				reversed: true,
				reversedStacks: true,
			},

			yAxis: {
				opposite: true,
				allowDecimals: false,
				title: {
					text: "",
				},
				labels: {
					formatter: function() {
						return Vue.options.filters.KR(this.value);
					},
					style: { fontSize: "1rem", color: colors.DarkGrey, },
				},
				tickPixelInterval: 150,
				gridLineColor: colors.LightGrey,
				plotLines: [{
					color: colors.Black,
					width: 2,
					value: 0,
					zIndex: 2,
				}]
			},

			tooltip: {
				formatter: function() {
					return (
						"<b>" +
						this.series.name +
						"<br>" + Vue.prototype.$t("Nettoomsättning") + ": " +
						Vue.options.filters.TKR(this.y)
					);
				},
				style: { fontSize: "1.25rem" },
				backgroundColor: colors.Light,
			},

			plotOptions: {
				column: {
					borderColor: colors.DarkGrey,
				},
			},

			series: this.overview.map((o, i) => {
				return {
					name: o.NAME,
					data: this.profitloss[i].sheets.map((s) => s.A),
				};
			}),
		});
	},
};
</script>

<style scoped lang="scss">
.dot {
	height: 20px;
	width: 20px;
	border-radius: 50%;
	display: inline-block;
}

.grey {
	background-color: col("colors.LightGrey");
}

.center {
	font-size: 1.2rem;
}
</style>
